module.exports = __webpack_public_path__ + "img/icon_i_common.ae93acba.png";